module.exports = __webpack_public_path__ + "tables/media/Logout_outlined.48569050.svg";